// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iview from 'view-design'
import 'view-design/dist/styles/iview.css'
import store from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import less from 'less'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
// Vue.use(router)
Vue.use(iview)
Vue.use(VueAxios, axios)
Vue.use(less)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  // console.log(to.meta.content)
  if (to.meta.content) {
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js